export default {
  name(name) {
    return 'web-' + name  
  },
  set(name, value) {
    window.localStorage.setItem(this.name(name), typeof value == 'object' ? JSON.stringify(value) : value )
  },

  get(name) {
    let value = window.localStorage.getItem(this.name(name))
    if(!value) return value
    
    return value.startsWith('{') || value.startsWith('[') ? JSON.parse(value) : value
  },

  del(name) {
    window.localStorage.removeItem(this.name(name))
  }
}